import api from "assets/services/api.js";

export const signInService = async (username, password) => {
    try{
        const response = await api.post('/login', {
          username,
          password
          });
        return response;
          } catch(err){
                  alert('Login e/ou senha inválidos');
        }
        
}